module.exports = {
        props:{
            app:true
        },
        data: function () {
            return {}
        },
        methods: {},
        components: {},
        ready: function () {

        }
    }


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/apps/custom-app.vue
 ** module id = 81
 ** module chunks = 0
 **/